import Axios from "../../configs/axios.config";

export const createDesignation = (data) => Axios.post(`/workspace/designation`, data).then(response=>response.data.data);
export const updateDesignation = (data, id) => Axios.put(`/workspace/designation/${id}`, data).then(response=>response.data.data);
export const getDesignationList = (data) => Axios.get('/workspace/designation', { params: data }).then(response=>response.data);
export const getDesignationDetail = (id) => Axios.get(`/workspace/designation/${id}`).then(response=>response.data.data);
export const deleteDesignation = (id) => Axios.delete(`/workspace/designation/${id}`);
